export default {
  SENT: 'SENT',
  READ: 'READ',
};
